import React, {useEffect, useRef, useState} from 'react';
import {
  FiAlertCircle,
  FiCheckCircle,
  FiChevronDown, FiChevronLeft,
  FiChevronRight,
  FiChevronUp,
  FiEdit, FiEye,
  FiHome,
  FiTrash,
  FiXOctagon
} from "react-icons/fi";
import cx from "classnames";
import {useTranslation} from "react-i18next";
import Modal from "../Modal";
import {useForm} from "react-hook-form";
import {Link} from "react-router-dom";
import {deleteTenant, getAllTenantsPage} from "../../services/tenantService";

function DeleteModal({close, clientId, fetchClients}){

  const {t} = useTranslation();

  const submit = ()=>{
    deleteTenant(clientId)
      .then((res)=>{
        fetchClients();
        close();
      })
      .catch((err)=> console.log(err) );
  }

  return(
    <div className='flex flex-col items-center' >
      <FiAlertCircle size={64} color='#D6323A' />
      <p className='mt-4 font-bold text-lg' >{t("MASTER.CLIENTS.DELETE_MODAL.TITLE")}</p>

      <div className='w-full mt-6 flex items-center justify-between px-10' >
        <button onClick={()=> close() } className='hover:text-azure hover:border-azure flex items-center gap-2 px-2.5 py-1.5 rounded-lg border text-xs font-semibold text-gray-600' >
          {t("COMMON.CANCEL")}
        </button>
        <button onClick={()=> submit() } className='flex items-center gap-2 px-2.5 py-1.5 rounded-lg border border-purple-light bg-purple-light text-xs font-semibold text-white hover:shadow-lg' >
          {t("COMMON.DELETE")}
        </button>
      </div>
    </div>
  )
}

function MasterClients(props) {

  const {t} = useTranslation();

  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLastPage, setIsLastPage] = useState(false);
  const [page, setPage] = useState(1);
  const [sizeOfPage, setSizeOfPage] = useState(10);

  const [isAddClientModalOpen, setIsAddClientModalOpen] = React.useState(false);
  const [isDeleteClientModalOpen, setIsDeleteClientModalOpen] = React.useState(false);
  const [modalData, setModalData] = useState(null);

  const openAddClientModal = () => {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    setIsAddClientModalOpen(true);
  }
  const closeAddClientModal = () => {
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
    setIsAddClientModalOpen(false);
  }
  const openDeleteClientModal = (clientId) => {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    setModalData(clientId)
    setIsDeleteClientModalOpen(true);
  }
  const closeDeleteClientModal = () => {
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
    setIsDeleteClientModalOpen(false);
    setModalData({});
  }

  const fetchClients = () => {
    setLoading(true);
    getAllTenantsPage(page, sizeOfPage)
      .then((data)=>{ setClients(data.content); setIsLastPage(data.last) })
      .catch((err) => {console.log(err)})
      .finally(()=> setLoading(false) )
  }

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <div>
      <div className="text-gray-500 flex items-center gap-2 mt-2 mb-6">
        <span className="text-xs font-semibold flex items-center">
          <FiHome size={12}/> <FiChevronRight size={12}/>
        </span>
        <h4 className="text-xs font-semibold text-gray-500">{t("MASTER.NAV.CLIENTS")}</h4>
      </div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold">{t("MASTER.CLIENTS.TITLE")}</h1>
        <Link to='/new-client'
              className="cursor-pointer bg-purple-light px-4 py-2 text-sm font-semibold rounded-lg text-white hover:opacity-60 hover:shadow">
          {t("MASTER.CLIENTS.ADD_BTN")}
        </Link>
      </div>
      <div className="bg-white p-0 rounded-lg customShadow">
        <table className="min-w-full border-collapse" id='my-applications-table'>
          <thead className="bg-gray-100 customShadow">
          <tr>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">{t("MASTER.CLIENTS.NEW_CLIENT.FORM.INTITULE")}</th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">{t("COMMON.LAST_NAME")}</th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">{t("COMMON.FIRST_NAME")}</th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">{t("COMMON.EMAIL")}</th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">{t("MASTER.CLIENTS.NEW_CLIENT.FORM.QUALITY")}</th>
            <th/>
          </tr>
          </thead>
          <tbody className="text-gray-800 text-sm ">
            {
              clients.map((it)=>
                <tr key={it.id} className={cx('border', {'text-gray-400': !it.enabled})} >
                  <td className="text-left py-3 px-2">{it.intitule}</td>
                  <td className="text-left py-3 px-2">{it.nom}</td>
                  <td className="text-left py-3 px-2">{it.prenom}</td>
                  <td className="text-left py-3 px-2">{it.email}</td>
                  <td className="text-left py-3 px-2">{it.qualite}</td>
                  <td className='w-24' >
                    <div className='flex items-center gap-4' >
                      <Link to={`/show-client/${it.id}`}>
                        <FiEye size={16} className='hover:text-purple-light cursor-pointer text-sky-500' />
                      </Link>
                      <Link to={`/edit-client/${it.id}`}>
                        <FiEdit size={16} className='hover:text-purple-light cursor-pointer text-yellow-500' />
                      </Link>
                      <FiTrash onClick={()=> openDeleteClientModal(it.id) } size={16} className='hover:text-red-700 cursor-pointer text-red-600' />
                    </div>
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
      <div className='mt-4 flex items-center justify-between'>
        <div className='flex gap-3 items-center'>
          <button onClick={() => page > 1 && setPage(page - 1)}
                  className='border rounded-full p-1 hover:text-purple-light hover:border-purple-light'>
            <FiChevronLeft size={16}/>
          </button>
          <span className='font-semibold text-sm'>{page}</span>
          <button onClick={() => !isLastPage && setPage(page + 1)}
                  className='border rounded-full p-1 hover:text-purple-light hover:border-purple-light'>
            <FiChevronRight size={16}/>
          </button>
        </div>
        <div className='flex items-center w-max gap-5'>
          <label className='w-max text-sm'>{t("COMMON.PAGINATION_TITLE")}</label>
          <select id="sizeOfPage" defaultValue={10} onChange={(e) => setSizeOfPage(e.target.value)}
                  className="appearance-none bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-14 p-2">
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
          </select>
        </div>
      </div>
      <Modal isOpen={isDeleteClientModalOpen} close={closeDeleteClientModal} title="Supprimier le Client" >
        <DeleteModal close={closeDeleteClientModal} clientId={modalData} fetchClients={fetchClients} />
      </Modal>
    </div>
  );
}

export default MasterClients;
